import { render, staticRenderFns } from "./ValidateUpload.vue?vue&type=template&id=1213b52e&scoped=true&"
import script from "./ValidateUpload.vue?vue&type=script&lang=js&"
export * from "./ValidateUpload.vue?vue&type=script&lang=js&"
import style0 from "./ValidateUpload.vue?vue&type=style&index=0&id=1213b52e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213b52e",
  null
  
)

export default component.exports